import { api } from './_apiInterface';
import { appName, pointer } from 'src/app-config';
import { generalHelpers } from '@monorepo/helpers';
import { typeConfigDoc, typeDbBackup } from '@monorepo/models';
import JSZip from 'jszip';

class ConfigServices {
    private Base = pointer.config;
    //
    DownloadDbBackup = async (all: boolean) => {
        const response = await api.SendRequest<{ dbBackup: typeDbBackup | null; dbBackups: Array<typeDbBackup | null> | null; }>(`${this.Base}/db-backup?all=${all}`, 'GET');
        if (!response.success || !response.data) {
            return response;
        }
        const dbBackups = all ? response.data.dbBackups : [response.data.dbBackup];
        if (!dbBackups) {
            return response;
        }
        try {
            const zip = new JSZip();
            const name = `Backup_${generalHelpers.GetCurrentLocalDate()}_${appName.replace(' ', '')}${dbBackups.length > 1 ? '_Completo' : ''}`;
            for (const dbBackup of dbBackups) {
                if (!dbBackup?.configDoc) {
                    continue;
                }
                if (dbBackup.boardDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}BoardItems.json`, JSON.stringify(dbBackup.boardDoc, null, 4));
                }
                if (dbBackup.cartsDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}CartsDoc.json`, JSON.stringify(dbBackup.cartsDoc, null, 4));
                }
                if (dbBackup.configDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}ConfigDoc.json`, JSON.stringify(dbBackup.configDoc, null, 4));
                }
                if (dbBackup.houseToHouseTerritories) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}HouseToHouseTerritories.json`, JSON.stringify(dbBackup.houseToHouseTerritories, null, 4));
                }
                if (dbBackup.logsDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}Logs.json`, JSON.stringify(dbBackup.logsDoc, null, 4));
                }
                if (dbBackup.meetingsDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}MeetingsDoc.json`, JSON.stringify(dbBackup.meetingsDoc, null, 4));
                }
                if (dbBackup.notificationsDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}NotificationsDoc.json`, JSON.stringify(dbBackup.notificationsDoc, null, 4));
                }
                if (dbBackup.publicMinistryDoc) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}PublicMinistryDoc.json`, JSON.stringify(dbBackup.publicMinistryDoc, null, 4));
                }
                if (dbBackup.telephonicTerritories) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}TelephonicTerritories.json`, JSON.stringify(dbBackup.telephonicTerritories, null, 4));
                }
                if (dbBackup.users) {
                    zip.folder(name)?.file(`${dbBackups.length > 1 ? `C${dbBackup.configDoc.congregation}_` : ''}Users.json`, JSON.stringify(dbBackup.users, null, 4));
                }
            }
            zip.generateAsync({ type: 'blob' }).then((content) => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(content);
                a.download = `${name}.zip`;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        } catch (error) {
            console.log(error);
        }
        return response;
    }
    // Get = async () => {
    //     const data = await api.SendRequest<{ config: typeConfigDoc | null; }>(this.Base, 'GET');
    //     return data;
    // }
    GetCongregations = async () => {
        const data = await api.SendRequest<{ congregations: Array<{ id: number; name: string; }> }>(`${this.Base}/all`, 'GET');
        return data;
    }
    RemoveCongregation = async (congregation: { id: number; name: string; }) => {
        const data = await api.SendRequest(this.Base, 'DELETE', { congregation });
        return data;
    }
    SendInvitationForNewUser = async (email: string, newCongregation: boolean = false) => {
        const data = await api.SendRequest(`${this.Base}/invite`, 'PUT', { email, newCongregation });
        return data;
    }
    SetAVUshersIsEnabledPublicPage = async (avUsherssIsEnabledPublicPage: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { avUsherssIsEnabledPublicPage });
        return data;
    }
    SetCartsIsEnabledPublicPage = async (cartsIsEnabledPublicPage: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { cartsIsEnabledPublicPage });
        return data;
    }
    SetCleaningIsEnabledPublicPage = async (isEnabledCleaningPublicPage: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { isEnabledCleaningPublicPage });
        return data;
    }
    SetCongregationArea = async (congregationArea: string) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { congregationArea });
        return data;
    }
    SetCongregationName = async (name: string) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { name });
        return data;
    }
    SetDisableEditMaps = async (disableEditHthMaps: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { disableEditHthMaps });
        return data;
    }
    SetDisableHthBuildingsForUnassignedUsers = async (disableHthBuildingsForUnassignedUsers: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { disableHthBuildingsForUnassignedUsers });
        return data;
    }
    SetDisableHthFaceObservatios = async (disableHthFaceObservations: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { disableHthFaceObservations });
        return data;
    }
    SetHthIsSharingAll = async (shareAll: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { shareAll });
        return data;
    }
    SetIsEnabledHthDoubleState = async (isEnabledHthDoubleState: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { isEnabledHthDoubleState });
        return data;
    }
    SetUsingLettersForBlocks = async (useLettersForBlocks: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { useLettersForBlocks });
        return data;
    }
}

export const configServices = new ConfigServices();
